import { render, staticRenderFns } from "./OrderThanks.vue?vue&type=template&id=256f14ae&scoped=true&"
import script from "./OrderThanks.vue?vue&type=script&lang=js&"
export * from "./OrderThanks.vue?vue&type=script&lang=js&"
import style0 from "./OrderThanks.vue?vue&type=style&index=0&id=256f14ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f14ae",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/order_thanks.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FOrderThanks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports